export default {
  not_started: 'Configura tu cuenta de pagos: tu reparto de ingresos está en espera hasta que se verifique.',
  bank_account_missing:
    'Añade una cuenta bancaria para los pagos: tu reparto de ingresos está en espera hasta que lo hagas.',
  incomplete:
    'Tu cuenta de pagos aún no está totalmente verificada: tu reparto de ingresos está en espera hasta que lo esté.',
  add_bank_account: 'Añadir cuenta bancaria',
  cta: 'Completar configuración',
};
